import { GRID_CHECKBOX_SELECTION_COL_DEF, GridActionsCellItem } from "@mui/x-data-grid-pro";
import React from "react";
import MoreVertIcon from "../../resources/images/icons-more-vertical.svg";
import type { BaseTableRow, TableColumnDef, TableProps } from "../../types/components/table.types";
import { getHeaderName } from "../../types/components/table.types";
import { Table } from "./Table";

interface JobBenchmarkingTableRow extends BaseTableRow {
  id: string;
  yourJob?: string;
  industryStandardJob?: string;
  name?: string;
  actions?: string;
  checkbox?: string;
}

interface JobBenchmarkingTableOwnProps<
  T extends JobBenchmarkingTableRow = JobBenchmarkingTableRow
> extends TableProps<T> {}

export class JobBenchmarkingTable<
  T extends JobBenchmarkingTableRow = JobBenchmarkingTableRow
> extends Table<T, JobBenchmarkingTableOwnProps<T>> {
  static columns = {
    yourJob: {
      field: "yourJob",
      label: "tableColumns.yourJob"
    },
    industryStandardJob: {
      field: "industryStandardJob",
      label: "tableColumns.klayoIntelligenceJob"
    },
    name: {
      field: "name",
      label: "tableColumns.name"
    },
    actions: {
      field: "actions",
      label: "tableColumns.actions"
    },
    checkbox: {
      field: "checkbox"
    }
  };

  static defaultProps = {
    ...Table.defaultProps
  };

  constructor(props: JobBenchmarkingTableOwnProps<T>) {
    super(props);

    this.state = {
      ...this.state,
      sortModel: this.props.sortModel
        ? this.props.sortModel
        : [
            {
              field: "name",
              sort: "asc"
            }
          ]
    };
  }

  getRowId(e: T) {
    return e.id;
  }

  initColumns() {
    const { columns, onActionMenu } = this.props;

    this.columns = [];

    if (!columns) return;

    columns.forEach((c) => {
      if (this.hasColumn(c)) {
        if (c.type === JobBenchmarkingTable.columns.yourJob)
          this.columns.push({
            field: JobBenchmarkingTable.columns.yourJob.field,
            headerName: getHeaderName(c, this.props.translate),
            sortable: c.sortable ?? true,
            filterable: false,
            disableReorder: true,
            flex: 1,
            cellClassName: c.cellClassName,
            headerClassName: c.headerClassName,
            valueGetter: (_value, row) =>
              row.isRenamed || row.isAdded ? row.industryStandardJob : row.yourJob
          });
        if (c.type === JobBenchmarkingTable.columns.industryStandardJob)
          this.columns.push({
            field: JobBenchmarkingTable.columns.industryStandardJob.field,
            headerName: getHeaderName(c, this.props.translate),
            sortable: c.sortable ?? true,
            filterable: false,
            disableReorder: true,
            flex: 1,
            cellClassName: c.cellClassName,
            headerClassName: c.headerClassName,
            valueGetter: (_value, row) => row.industryStandardJob
          });
        if (c.type === JobBenchmarkingTable.columns.actions)
          this.columns.push({
            field: "actions",
            type: "actions",
            filterable: false,
            align: "right",
            width: 50,
            disableReorder: true,
            getActions: (params) => [
              <GridActionsCellItem
                icon={<MoreVertIcon />}
                label='Actions'
                onClick={(e) => onActionMenu?.(e, params.row)}
                key={Math.random().toString(36).substring(7)}
              />
            ]
          });
        if (c.type === JobBenchmarkingTable.columns.name)
          this.columns.push({
            field: JobBenchmarkingTable.columns.name.field,
            headerName: getHeaderName(c, this.props.translate),
            sortable: c.sortable ?? true,
            filterable: false,
            disableReorder: true,
            flex: 1,
            valueGetter: (_value, row) => row.name
          });
        if (c.type === JobBenchmarkingTable.columns.checkbox)
          this.columns.push(GRID_CHECKBOX_SELECTION_COL_DEF as TableColumnDef<T>);
      }
    });
  }
}
